import React, { FC } from 'react'

export const IconPlay: FC = () => {
  return (
    <svg width="27" height="31" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25 12.0359C27.6667 13.5755 27.6667 17.4245 25 18.9641L6.25 29.7894C3.58333 31.329 0.249998 29.4045 0.249999 26.3253L0.25 4.67468C0.25 1.59548 3.58333 -0.329021 6.25 1.21058L25 12.0359Z"
        fill="white"
      />
    </svg>
  )
}
